import { css, html } from 'lit';

import '../elements/d-label.js';
import './d-list-header.js';
import './d-list-section.js';
import '../elements/d-action.js';
import '../elements/d-section.js';
import '../fields/d-expansion.js';
import '../editors/elements/d-select-dropdown.js';
import { customElement, property } from 'lit/decorators.js';
import { t } from 'src/i18n';
import { EventList } from 'src/library/abstracts/event-list.js';

import type { ListSectionItemInput } from './listSectionItemInput';

/**
 *
 * STATUS OK
 */
@customElement('d-todo-list-section')
export class DTodoListSection extends EventList<ListSectionItemInput> {
  static readonly styles = css`
    :host {
      display: block;
    }
  `;
  @property({ type: Array })
  items: ListSectionItemInput[] = [];

  private get hasNotes() {
    return this._hasNotes(
      this.items.filter((i) => {
        return this.showAll || i.eventCurrentUser;
      }),
    );
  }

  _todoActions() {
    const actions = this._actions(this.hasNotes);
    actions.push({
      name: t('library.todo.hideCompleted'),
      action: 'showOptions',
      slot: 'top-right',
    });
    return actions;
  }

  render() {
    return html`
      <d-list-section
        .label=${t('library.todo.soonest')}
        icon="events"
        .noItemText=${t('library.todo.noTasks')}
        big-label
        bordered
        theme-page
        .actions=${this._todoActions()}
        .items=${this._eventsWithFilterProperties(this.items)}
        ?showNotes=${this.showNotes}
        @action=${(e) => this._fireAction(e.detail)}
        .contentStickyTop=${this.contentStickyTop}
      ></d-list-section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-todo-list-section': DTodoListSection;
  }
}
